<template>
  <div />
</template>

<script>
import PermissionService from '@/services/PermissionService';
import * as AuthenticationService from '../services/AuthenticationService.js';

export default {
  data() {
    return {
      code: this.$route.query.code,
    };
  },
  async created() {
    const vm = this;
    vm.$store.dispatch('loadLoginStatus');
    try {
      const response = await PermissionService.ActivateInvitationAsync(vm.code);

      // 設置為邀請code對應公司
      this.$store.commit('setCompany', response.data.companyId);
      this.$router.replace({ path: '/' });
    } catch (err) {
      switch (err.response.status) {
        case 400:
          vm.$router.replace({ name: 'Unauthorized' });
          break;
        case 401:
          if (err.response.data) {
            await AuthenticationService.LogoutAsync();
            // 使用者已建立
            if (err.response.data.status === '1002') {
              vm.$router.replace({ name: 'Login', query: { redirect: vm.$route.fullPath } });
            } else if (err.response.data.status === '1003') {
              vm.$router.replace({ name: 'Register', query: { redirect: vm.$route.fullPath }, params: { code: vm.code } });
            }
          }
          break;
        case 403:
          if (err.response.data) {
            await AuthenticationService.LogoutAsync();
            // 使用者已建立
            if (err.response.data.status === '1002') {
              vm.$router.replace({ name: 'Login', query: { redirect: vm.$route.fullPath } });
            } else if (err.response.data.status === '1003') {
              vm.$router.replace({ name: 'Register', query: { redirect: vm.$route.fullPath }, params: { code: vm.code } });
            }
          }
          break;
        default:
          break;
      }
    }
  },
};
</script>
